import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  input,
  output,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { RippleModule } from 'primeng/ripple';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ClientService, ToastMessageService } from '@fitness-force/api';

@Component({
  selector: 'sync-client-dialog',
  templateUrl: './sync-client-dialog.component.html',
  styleUrls: ['./sync-client-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonModule, DialogModule, RippleModule, TranslateModule],
})
export class SyncClientDialogComponent {
  readonly visible = input(false);
  readonly clientId = input<number>(0);
  readonly closePopup = output<boolean>();

  isSyncing = false;

  constructor(
    private clientService: ClientService,
    private toastMessageService: ToastMessageService,
    private translate: TranslateService,
    private cd: ChangeDetectorRef,
  ) {}

  closeDialog(success: boolean) {
    this.closePopup.emit(true);
    this.closePopup.emit(success);
  }

  syncClientToServer() {
    const clientId = this.clientId();
    if (!clientId || this.isSyncing) {
      return;
    }

    this.isSyncing = true;
    this.cd.detectChanges();

    this.clientService.syncClientToExternalSystems(clientId).subscribe({
      next: (response) => {
        this.isSyncing = false;
        this.translate
          .get('CLIENT_PROFILE.SYNC_CLIENT.SUCCESS_MESSAGE')
          .subscribe((translation) => {
            this.toastMessageService.showSuccess(translation);
          });
        this.cd.detectChanges();
        // Close dialog on success
        this.closeDialog(true);
      },
      error: (error) => {
        this.isSyncing = false;
        this.translate
          .get('CLIENT_PROFILE.SYNC_CLIENT.ERROR_MESSAGE')
          .subscribe((translation) => {
            this.toastMessageService.showErrorMessage(translation);
          });
        this.cd.detectChanges();
        // Keep dialog open on error - don't call closeDialog
      },
    });
  }
}
